import {composeReducers} from '@logistics-frontend/utils/redux'
import {combineReducers} from 'redux'

const identity = <TState = unknown>(state: TState) => state || null
const rootReducer = composeReducers(
  combineReducers({
    config: identity,
  }) as (state: unknown) => unknown,
)

export default rootReducer
